import {useMutation} from 'react-query';
import {userSendrMessages} from 'services/farm/chatMessages';

export const useSendUserChat = ({
  refresh,
}: IUserSendChatHook) => {
  const {isLoading, mutate} = useMutation({
    mutationFn: (payload: IUserSendChatPayload) => {
      return userSendrMessages(payload);
    },
    onSuccess: (_, {clearInput}) => {
      refresh();
      clearInput();
    },
  });
  return {isLoading, mutate};
};
